export const lineups = [
  {
    lastLineup: {
      match: {
        date: '2026-03-27',
        displayDate: '27 DE MARZO',
        displayTime: '19:00',
        timeZoneLabel: 'ARG',
        formation: '4-3-3',
      },
    },
    coach: {
      coachId: 'coach-civ-001',
      name: 'Emerse Faé',
      number: null,
      image: 'https://cdn.example.com/coaches/coach-civ-001.png',
      birthDate: '1984-01-24',
      displayBirthDate: '24 Jan 1984',
      age: 42,
    },
    goalkeeper: [
      {
        playerId: 'civ-gk-001',
        name: 'Yahia Fofana',
        number: 1,
        position: 'GK',
        image: 'https://cdn.example.com/players/civ-gk-001.png',
        birthDate: '2000-08-21',
        displayBirthDate: '21 Aug 2000',
        age: 25,
        displayInfo: '21 Aug 2000 (25 años)',
        isStarter: true,
        showInFormationMap: true,
        formationMap: { x: 50, y: 10 },
        movements: [],
      },
    ],
    defenders: [
      {
        playerId: 'civ-df-017',
        name: 'Serge Aurier',
        number: 17,
        position: 'DF',
        image: 'https://cdn.example.com/players/civ-df-017.png',
        birthDate: '1992-12-24',
        displayBirthDate: '24 Dec 1992',
        age: 33,
        displayInfo: '24 Dec 1992 (33 años)',
        isStarter: true,
        showInFormationMap: true,
        formationMap: { x: 12, y: 28 },
        movements: [
          { type: 'SUBSTITUTION_OUT', name: 'Cambio', minute: 72 },
        ],
      },
      {
        playerId: 'civ-df-007',
        name: 'Odilon Kossounou',
        number: 7,
        position: 'DF',
        image: 'https://cdn.example.com/players/civ-df-007.png',
        birthDate: '2001-01-04',
        displayBirthDate: '04 Jan 2001',
        age: 25,
        displayInfo: '04 Jan 2001 (25 años)',
        isStarter: true,
        showInFormationMap: true,
        formationMap: { x: 35, y: 24 },
        movements: [],
      },
      {
        playerId: 'civ-df-021',
        name: 'Evan Ndicka',
        number: 21,
        position: 'DF',
        image: 'https://cdn.example.com/players/civ-df-021.png',
        birthDate: '1999-08-20',
        displayBirthDate: '20 Aug 1999',
        age: 26,
        displayInfo: '20 Aug 1999 (26 años)',
        isStarter: true,
        showInFormationMap: true,
        formationMap: { x: 65, y: 24 },
        movements: [],
      },
      {
        playerId: 'civ-df-003',
        name: 'Ghislain Konan',
        number: 3,
        position: 'DF',
        image: 'https://cdn.example.com/players/civ-df-003.png',
        birthDate: '1995-12-27',
        displayBirthDate: '27 Dec 1995',
        age: 30,
        displayInfo: '27 Dec 1995 (30 años)',
        isStarter: true,
        showInFormationMap: true,
        formationMap: { x: 88, y: 28 },
        movements: [],
      },
      {
        playerId: 'civ-df-018',
        name: 'Wilfried Singo',
        number: 18,
        position: 'DF',
        image: 'https://cdn.example.com/players/civ-df-018.png',
        birthDate: '2000-12-25',
        displayBirthDate: '25 Dec 2000',
        age: 25,
        displayInfo: '25 Dec 2000 (25 años)',
        isStarter: false,
        showInFormationMap: false,
        formationMap: null,
        movements: [
          { type: 'SUBSTITUTION_IN', name: 'Cambio', minute: 72 },
        ],
      },
    ],
    midfielders: [
      {
        playerId: 'civ-mf-008',
        name: 'Franck Kessié',
        number: 8,
        position: 'MF',
        image: 'https://cdn.example.com/players/civ-mf-008.png',
        birthDate: '1996-12-19',
        displayBirthDate: '19 Dec 1996',
        age: 29,
        displayInfo: '19 Dec 1996 (29 años)',
        isStarter: true,
        showInFormationMap: true,
        formationMap: { x: 28, y: 52 },
        movements: [
          { type: 'YELLOW_CARD', name: 'Tarjeta amarilla', minute: 54 },
        ],
      },
      {
        playerId: 'civ-mf-006',
        name: 'Seko Fofana',
        number: 6,
        position: 'MF',
        image: 'https://cdn.example.com/players/civ-mf-006.png',
        birthDate: '1995-05-07',
        displayBirthDate: '07 May 1995',
        age: 30,
        displayInfo: '07 May 1995 (30 años)',
        isStarter: true,
        showInFormationMap: true,
        formationMap: { x: 50, y: 48 },
        movements: [],
      },
      {
        playerId: 'civ-mf-026',
        name: 'Jean Michaël Seri',
        number: 26,
        position: 'MF',
        image: 'https://cdn.example.com/players/civ-mf-026.png',
        birthDate: '1991-07-19',
        displayBirthDate: '19 Jul 1991',
        age: 34,
        displayInfo: '19 Jul 1991 (34 años)',
        isStarter: true,
        showInFormationMap: true,
        formationMap: { x: 72, y: 52 },
        movements: [
          { type: 'SUBSTITUTION_OUT', name: 'Cambio', minute: 63 },
        ],
      },
      {
        playerId: 'civ-mf-04',
        name: 'Ibrahim Sangaré',
        number: 4,
        position: 'MF',
        image: 'https://cdn.example.com/players/civ-mf-04.png',
        birthDate: '1997-12-02',
        displayBirthDate: '02 Dec 1997',
        age: 28,
        displayInfo: '02 Dec 1997 (28 años)',
        isStarter: false,
        showInFormationMap: false,
        formationMap: null,
        movements: [
          { type: 'SUBSTITUTION_IN', name: 'Cambio', minute: 63 },
        ],
      },
      {
        playerId: 'civ-mf-015',
        name: 'Lazare Amani',
        number: 15,
        position: 'MF',
        image: 'https://cdn.example.com/players/civ-mf-015.png',
        birthDate: '1998-03-07',
        displayBirthDate: '07 Mar 1998',
        age: 28,
        displayInfo: '07 Mar 1998 (28 años)',
        isStarter: false,
        showInFormationMap: false,
        formationMap: null,
        movements: [],
      },
    ],
    forwards: [
      {
        playerId: 'civ-fw-024',
        name: 'Simon Adingra',
        number: 24,
        position: 'FW',
        image: 'https://cdn.example.com/players/civ-fw-024.png',
        birthDate: '2002-01-01',
        displayBirthDate: '01 Jan 2002',
        age: 24,
        displayInfo: '01 Jan 2002 (24 años)',
        isStarter: true,
        showInFormationMap: true,
        formationMap: { x: 18, y: 78 },
        movements: [],
      },
      {
        playerId: 'civ-fw-009',
        name: 'Sébastien Haller',
        number: 9,
        position: 'FW',
        image: 'https://cdn.example.com/players/civ-fw-009.png',
        birthDate: '1994-06-22',
        displayBirthDate: '22 Jun 1994',
        age: 31,
        displayInfo: '22 Jun 1994 (31 años)',
        isStarter: true,
        showInFormationMap: true,
        formationMap: { x: 50, y: 84 },
        movements: [
          { type: 'GOAL', name: 'Gol', minute: 61 },
        ],
      },
      {
        playerId: 'civ-fw-019',
        name: 'Nicolas Pépé',
        number: 19,
        position: 'FW',
        image: 'https://cdn.example.com/players/civ-fw-019.png',
        birthDate: '1995-05-29',
        displayBirthDate: '29 May 1995',
        age: 30,
        displayInfo: '29 May 1995 (30 años)',
        isStarter: true,
        showInFormationMap: true,
        formationMap: { x: 82, y: 78 },
        movements: [
          { type: 'SUBSTITUTION_OUT', name: 'Cambio', minute: 80 },
        ],
      },
      {
        playerId: 'civ-fw-013',
        name: 'Jérémie Boga',
        number: 13,
        position: 'FW',
        image: 'https://cdn.example.com/players/civ-fw-013.png',
        birthDate: '1997-01-03',
        displayBirthDate: '03 Jan 1997',
        age: 29,
        displayInfo: '03 Jan 1997 (29 años)',
        isStarter: false,
        showInFormationMap: false,
        formationMap: null,
        movements: [
          { type: 'SUBSTITUTION_IN', name: 'Cambio', minute: 80 },
        ],
      },
    ],
  },
];
